// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pikipek: PokeData = {
  "id": 731,
  "name": "pikipek",
  "height": 3,
  "weight": 12,
  "base_experience": 53,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "fury-attack",
    "growl",
    "supersonic",
    "peck",
    "drill-peck",
    "screech",
    "rock-smash",
    "feather-dance",
    "hyper-voice",
    "bullet-seed",
    "roost",
    "pluck",
    "echoed-voice"
  ],
  "moves": [
    "growl",
    "supersonic",
    "peck",
    "rock-smash",
    "hyper-voice",
    "bullet-seed",
    "roost",
    "air-slash",
    "scratch",
    "purification",
    "leer",
    "sky-attack",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 377,
    "item": null,
    "species": [
      {
        "name": "pikipek",
        "order": 731,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "trumbeak",
        "order": 732,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 731,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "toucannon",
        "order": 733,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 732,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 32.5,
    "speed": 65,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
